export const STORAGE_REPORTS_LEGAL_PERSON_ID = 'reports.legalPersonId';
export const STORAGE_REPORTS_SUMMARY_REPORT_FILTERS = 'eventSummaryReport.filters;'
